import type { OrganisationPeriodJobsLocales } from '../types';

const organisationPeriodJobsLocales: OrganisationPeriodJobsLocales = {
  accepted: 'Accepted',
  assignmentDetails: 'Assignment Details',
  assignmentInfo: 'Assignment information',
  assignments: 'Assignments',
  availability: 'Availability',
  available: 'Available',
  back: 'Back',
  byEndDate: 'By end date',
  byLocation: 'by location',
  byStartDate: 'By start date',
  cancelAssignment: 'Cancel assignment',
  cancelled: 'Cancelled',
  cancelPeriodJob: 'Cancel period job',
  certificates: 'Certificates',
  clearOrdering: 'Clear ordering',
  clickConvertToProceed: 'Click on convert to proceed.',
  clickToProceed: 'click on "{{action}}" to {{action}} the assignment',
  close: 'Close',
  closed: 'Closed',
  competences: 'Competences',
  confirm: 'Confirm',
  confirmAction: 'Confirm action',
  confirmCloseJob:
    'Do you want to close this period job? if you continue the job wont be visible for freelancers.',
  confirmConvertJob: 'Do you want to convert this assignment into urgent?',
  confirmed: 'Confirmed',
  confirmedJobFirst: 'Confirmed Jobs first',
  confirmFreelancer: 'Confirm freelancer',
  confirmFreelancerMessage:
    'Do you want to invite this freelancer to get this period job?',
  confirmHideJob:
    'Do you want to hide this period job? if you continue the job wont be visible for you anymore.',
  convert: 'Convert',
  converted: 'Converted',
  convertedToUrgent: 'Converted to urgent',
  convertToUrgent: 'Convert to urgent',
  dashboard: 'Dashboard',
  date: 'Date',
  days: 'Days',
  detailsAndConfirm: 'Details and confirm',
  documents: 'Documents',
  edit: 'Edit',
  editAssignment: 'Edit assignment',
  endDate: 'End date',
  endTime: 'End time',
  expired: 'Expired',
  explanation: 'Explanation',
  freelancer: 'Freelancer',
  freelancerAvailabilityStats:
    '{{available}} of the {{total}} assignments ({{perc}}%).',
  freelancerAvailabilityText: 'Freelancer is available for ',
  freelancerProfile: 'Freelancer Profile',
  freelancers: 'Freelancers',
  freelancersListHelpText:
    'These freelancers have signed up. View their profile or schedule one to fulfill the assignment.',
  hide: 'Hide',
  info1:
    'You enter the details of the service, the location and for what period.',
  info1Title: 'Placing an assignment',
  info2: 'The freelancers see the service and can show interest.',
  info2Title: 'Searching for candidates',
  info3:
    'You will see the interested pedagogical professionals and can contact them.',
  info3Title: 'Getting to know you (Optional)',
  info4: 'Assign a candidate to the services.',
  info4Title: 'Assign',
  invitedFreelancers: 'Invited freelancers',
  inviteFreelancer: 'Invite an other freelancer',
  jobCancelled: 'Assignment cancelled',
  JobConfirm: 'Confirm assignment',
  jobConverted: 'Assignment successfully converted to urgent',
  jobDetails: 'Assignment details',
  jobEdited: 'Assignment successfully edited!',
  location: 'Location',
  maximalTarif: 'Maximal rate',
  nb: 'Tip',
  nbContent:
    'As soon as there are enough candidates, you can close the registration.',
  newAssignement: 'New assignment',
  noAssignmentFound: 'No assignments Found for this Period job',
  noCertificatesRequired: 'No certificates required',
  noInterestedFreelancers: 'No freelancers have shown interest yet.',
  notAvailable: 'Not available',
  notFilledIn: 'not specified',
  numberIntersted: 'Number of interested freelancers',
  open: 'Open',
  OpenJobsFirst: 'Open jobs first',
  overview: 'Overview',
  pause: 'Pause',
  pending: 'Pending',
  period: 'Period',
  PeriodJobs: 'Period jobs',
  periodJobsDef:
    'Long assignments are intended as a tool to find a substitute for a longer period, for example in the event of an unfilled vacancy or a pregnancy. By placing a long assignment you can easily find a permanent face.',
  refused: 'Refused',
  remarks: 'Remarks',
  sort: 'Sort',
  startDate: 'Start date',
  startTime: 'Start time',
  status: 'Status',
  time: 'Time',
  total: 'Total',
};

export default organisationPeriodJobsLocales;
